export const environment = {
    apiUrl: 'https://apitest.phoenix.com.pe/api',
    apiUrlClean: 'https://apitest.phoenix.com.pe',
    meetingUrl: 'https://apptest.phoenix.com.pe/dashboard/meet/',
    meetingUrlConection: 'https://apptest.phoenix.com.pe/meet/',
    
    // Configuración de Jitsi Meet
    jitsiMeet: {
        domain: 'meet.phoenix.com.pe',
        apiScript: 'https://meet.phoenix.com.pe/external_api.js'
    },
    culqirsaid: 'phoenix-rsa-frontend',
    culqiPublicKey: 'pk_test_Br6bsCLqVdKTKPKD',
    culqiRsaPublicKey: `-----BEGIN PUBLIC KEY-----
    MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDAavdOW6JYWJrOgrMjNA+07RNw
    0zdVsmNSlWMOpbEBQNAJ3crZk04g99XB2xVAhlm/6H5iCyWhZSdoAbVCxOq7jqy+
    K5gLs9WrfzA25N2wWxjbujGo3YXcOm78kYiELSC5oQN+SKyr2xRHIB67HmOofpVA
    MvizAh6jyNTQfFF3HQIDAQAB
    -----END PUBLIC KEY-----`,

    // Configuración de Alignet Payment Gateway DEVELEPMENT
    alignet: {
        audience: "https://api.dev.alignet.io",
        client_id: "DDHPCApkLKAqGVL9xZvwXf0vKZB58u",
        client_secret: "4TLF5gSR3nDh3IkZSO4WttlbIuHNknliZdBWqpIovGfwhlUWED8JCYgxXKSyxfmT",
        merchant_code: "76d93365-15a0-4103-88da-07f8f6f762f0",
        urls: {
            auth: "https://auth.wip.alignet.io",
            api: "https://api.dev.alignet.io",
            css: "https://alignet-flex-demo.s3.amazonaws.com/main-flex-payment-forms.css",
            js: "https://alignet-flex-demo.s3.amazonaws.com/flex-payment-forms.min.js"
        }
    },


    // Configuración de Alignet Payment Gateway PREPRODUCTIOn
    // alignet: {
    //     audience: "https://api.preprod.alignet.io",
    //     client_id: "DDHPCApkLKAqGVL9xZvwXf0vKZB58u",
    //     client_secret: "4TLF5gSR3nDh3IkZSO4WttlbIuHNknliZdBWqpIovGfwhlUWED8JCYgxXKSyxfmT",
    //     merchant_code: "76d93365-15a0-4103-88da-07f8f6f762f0",
    //     urls: {
    //         auth: "https://auth.preprod.alignet.io",
    //         api: "https://api.preprod.alignet.io",
    //         css: "https://alignet-flex-demo.s3.amazonaws.com/main-flex-payment-forms.css",
    //         js: "https://alignet-flex-demo.s3.amazonaws.com/flex-payment-forms.min.js"
    //     }
    // },


    // Configuración de Alignet Payment Gateway  PRODUCTION
    // alignet: {
    //     audience: "https://api.alignet.io",
    //     client_id: "Q1bhIpsPy9Zyrg3jEGNOoIuJ6rouqK",
    //     client_secret: "7FrmJjWzdGNJKZkkabCNISq3dzcKfFSXWsvqvYM9amRirt3KqL960pRkkJs4JCtt",
    //     merchant_code: "55f18d56-d136-4045-b8e2-9eaaed23edfc",
    //     urls: {
    //         auth: "https://auth.alignet.io",
    //         api: "https://api.alignet.io",
    //         css: "https://flex.alignet.io/main-flex-payment-forms.css",
    //         js: "https://flex.alignet.io/flex-payment-forms.min.js"
    //     }
    // },

    // Configuración de Executive Banner y WhatsApp
    //salaryRanges: ['1-5k', '5k-10k', '10k-15k', '15k-20k', '20k+'],
    //highSalaryRanges: ['10k-15k', '15k-20k', '20k+'],
    salaryRanges: ['1000-2000 USD', '2001-3000 USD', '3001-4000 USD', '4001-5000 USD', '5001-más USD', 'Prefiero no responder'],
    highSalaryRanges: ['5001-más USD'],
    whatsapp: {
        phoneNumber: '51945849391',
        executiveMessage: 'Hola! Soy {userName} y he sido preseleccionado para Executive. Me gustaría agendar mi entrevista.'
    },
    urlVideo: 'https://www.youtube.com/watch?v=AS-p11g768I',
    urlVideoProfessional: 'https://www.youtube.com/watch?v=AS-p11g768I',

    // Configuración dinámica de rangos de gap
    gapRanges: [
        { key: '1-3', min: 1, max: 3 },
        { key: '4-6', min: 4, max: 6 },
        { key: '7-9', min: 7, max: 9 }
    ],

    // Configuración de tipos de gap
    gapTypes: {
        strength: ['1-3'],        // Rangos considerados como fortalezas
        opportunity: ['4-6', '7-9'] // Rangos considerados como oportunidades
    },

    // Configuración de mapeo de rangos a clases CSS
    gapCssClasses: {
        '1-3': { small: 'gap-small', small2: 'gap-small2' },
        '4-6': { small: 'gap-medium', small2: 'gap-medium2' },
        '7-9': { small: 'gap-large', small2: 'gap-large2' }
    },

    
    // Descripciones para resultados de assessment
    assessmentDescriptions: {
        'Salud y bienestar': {
            '1-3': 'Tu presente y tu futuro se alinean con armonía. Has construido hábitos que sostienen tu salud y bienestar, pero recuerda: lo que hoy es fortaleza puede debilitarse si lo descuidas. Mantén el ritmo y sigue invirtiendo en ti. Tu cuerpo es la base de todo. Planifiquemos juntos',
            '4-6': 'Vas por buen camino, pero pequeños descuidos pueden crecer. La OMS indica que 1 de cada 3 adultos descuida hábitos básicos de salud, aumentando riesgos a futuro. Con ajustes en tu rutina, tu bienestar puede convertirse en una fortaleza a largo plazo. Planifiquemos juntos',
            '7-9': 'La OMS señala que solo 30 minutos diarios de actividad física reducen un 30% el riesgo cardiovascular. Cada año que lo postergas, el esfuerzo será mayor. Empieza hoy a cuidar tu salud con un plan claro y planifiquemos juntos'
        },
        'Diversión': {
            '1-3': 'La alegría que disfrutas hoy también se proyecta hacia tu futuro. Has sabido equilibrar responsabilidad y disfrute, pero cuidado, la rutina puede apagar lo que hoy ilumina tu vida. Protege tu espacio de diversión, porque sin él el desgaste llegará. Crea tu plan de vida',
            '4-6': 'Tienes momentos de disfrute, aunque tu futuro refleja que podrían reducirse. Estudios muestran que dedicar al menos 2 horas semanales a ocio creativo disminuye el estrés en un 25%. No dejes que la rutina opaque tu alegría, reserva espacios para divertirte. Crea tu plan de vida',
            '7-9': 'Un estudio de Harvard Business Review muestra que quienes integran momentos de ocio creativo tienen un 34% menos de agotamiento (burnout). Si lo aplazas, tu energía y productividad se verán afectadas. Es hora de recuperar ese espacio para ti. Crea tu plan de vida'
        },
        'Crecimiento personal': {
            '1-3': 'Tu crecimiento no es casualidad: lo trabajas y lo proyectas. Pero la disciplina no es un logro estático, es un ejercicio constante. Si no alimentas tu curiosidad, podrías frenar tu propio avance. Sigue expandiendo tus límites. Crea tu objetivo',
            '4-6': 'Estás avanzando, aunque con intermitencias. Según LinkedIn, el 40% de profesionales que no se capacitan al menos una vez al año sienten estancamiento. Sumar prácticas constantes marcará la diferencia entre crecer un poco y florecer plenamente. Crea tu objetivo',
            '7-9': 'Según un estudio del World Economic Forum, el aprendizaje continuo reduce en un 40% la probabilidad de quedar rezagado profesionalmente. Cada semana que dejas pasar, tu ventaja se acorta. Invierte en ti ahora, no cuando sea demasiado tarde. Crea tu objetivo'
        },
        'Transformación': {
            '1-3': 'Has hecho del cambio una aliada, y eso te da ventaja. Sin embargo, toda transformación necesita renovarse para no volverse rutina. Mantén vivo tu impulso, lo que hoy es confianza puede volverse conformismo si no actúas. Planifiquemos juntos',
            '4-6': 'Das pasos hacia el cambio, pero podrías detenerte. McKinsey señala que el 70% de los intentos de cambio personal fracasan por falta de constancia. Tu impulso necesita continuidad. La transformación se construye día a día. Planifiquemos juntos',
            '7-9': 'El 70% de los ejecutivos que alcanzaron nuevas posiciones se reinventaron en los últimos 5 años. Si tú no inicias tu cambio hoy, otros ocuparán el espacio mañana. No esperes, tu transformación empieza ahora. Planifiquemos juntos'
        },
        'Círculos sociales': {
            '1-3': 'Tus relaciones son sólidas y consistentes, pero la conexión social se debilita si no se cultiva día a día. Lo que hoy florece puede marchitarse mañana si lo das por sentado. Refuerza y expande tu red. Crea tu plan de vida',
            '4-6': 'Mantienes vínculos, pero no todos se proyectan sólidos. El estudio de Harvard sobre felicidad demuestra que quienes cuidan sus relaciones reducen en un 45% el riesgo de depresión después de los 50. Refuerza hoy tu red para tener apoyo genuino mañana. Crea tu plan de vida',
            '7-9': 'El estudio más largo de Harvard sobre felicidad concluye que las relaciones sólidas son el mayor predictor de longevidad. A partir de los 50, quienes amplían su red reducen un 45% el riesgo de depresión. Fortalece tus vínculos hoy'
        },
        'Familia': {
            '1-3': 'Tu familia es un pilar estable, pero ningún lazo se mantiene fuerte sin cuidado constante. El tiempo perdido no vuelve. Lo que hoy disfrutas puede convertirse en distancia si no inviertes en ello ahora. Crea tu objetivo',
            '4-6': 'Tu conexión familiar es buena, pero con áreas a reforzar. Investigaciones señalan que compartir al menos 3 comidas familiares semanales incrementa un 20% la satisfacción en el hogar. Dedica más tiempo hoy para fortalecer tu base más importante. Crea tu objetivo',
            '7-9': 'El Stanford Center on Legvity reporta que el 60% de las personas que refuerzan sus lazos familiares reportan mayor satisfacción en la jubilación y menor sensación de soledad. Cada momento que postergas es un momento que no vuelve. Empieza hoy a fortalecer tu base más importante: tu familia. Crea tu objetivo'
        },
        'Trabajo y desarrollo profesional': {
            '1-3': 'Tu presente y tu futuro laboral caminan de la mano, pero la estabilidad profesional nunca es eterna. Si no renuevas tu preparación, lo que hoy es ventaja puede volverse rezago. Da el siguiente paso en tu carrera ahora. Planifiquemos juntos',
            '4-6': 'Tu presente es estable, pero tu proyección refleja altibajos. El 43% de ejecutivos que no actualizan sus competencias quedan fuera de ascensos clave. Invierte en aprendizaje y proactividad. Tu carrera necesita combustible constante. Planifiquemos juntos',
            '7-9': 'Según el Linkedin Economic Graph, el 43% de los profesionales que no inician networking temprano pierden oportunidades clave después de los 60. Cada año que esperas, tus opciones se reducen. Hoy es el mejor momento para avanzar en tu desarrollo profesional. Planifiquemos juntos'
        },
        'Ingresos económicos': {
            '1-3': 'Tus finanzas reflejan equilibrio y proyección, pero el mundo cambia y la estabilidad de hoy no garantiza la de mañana. Si no haces crecer esta fortaleza, la inflación y la incertidumbre pueden consumirla. Invierte en tu seguridad hoy. Crea tu plan de vida',
            '4-6': 'Tus finanzas están bajo control, aunque con cierta tensión. El Banco Mundial indica que 6 de cada 10 personas no tienen un fondo de emergencia sólido. Un mejor plan de gastos hoy puede darte la tranquilidad que buscas mañana. Crea tu plan de vida',
            '7-9': 'Según la Organización para la Cooperación y el Desarrollo Económicos, el 78% de quienes planifican sus finanzas con 10 años de anticipación logran estabilidad en la jubilación. Cada año que retrasas tu plan aumenta en un 12% el esfuerzo necesario. Empieza a construir tu seguridad financiera ahora. Crea tu plan de vida'
        }
    },

    // Descripciones para análisis de gap en objetivos
    gapDescriptions: {
        'Salud y Bienestar': {
            '1-3': 'La OMS señala que 30 min de actividad física reducen un 30% el riesgo cardiovascular. Descubre más hábitos en ',
            '4-6': 'La OMS señala que 30 min de actividad física reducen un 30% el riesgo cardiovascular. Descubre más hábitos en ',
            '7-9': 'La OMS señala que 30 min de actividad física reducen un 30% el riesgo cardiovascular. Descubre más hábitos en '
        },
        'Diversión': {
            '1-3': 'El ocio creativo reduce un 34% el burnout. Postergarlo afecta tu energía. Inspírate con lecturas en ',
            '4-6': 'El ocio creativo reduce un 34% el burnout. Postergarlo afecta tu energía. Inspírate con lecturas en ',
            '7-9': 'El ocio creativo reduce un 34% el burnout. Postergarlo afecta tu energía. Inspírate con lecturas en '
        },
        'Crecimiento Personal': {
            '1-3': 'El aprendizaje continuo reduce en 40% quedar rezagado. Encuentra prácticas clave en ',
            '4-6': 'El aprendizaje continuo reduce en 40% quedar rezagado. Encuentra prácticas clave en ',
            '7-9': 'El aprendizaje continuo reduce en 40% quedar rezagado. Encuentra prácticas clave en '
        },
        'Transformación': {
            '1-3': 'El 70% de los ejecutivos se reinventó en 5 años. ¿Y tú? Lee casos y guías en ',
            '4-6': 'El 70% de los ejecutivos se reinventó en 5 años. ¿Y tú? Lee casos y guías en ',
            '7-9': 'El 70% de los ejecutivos se reinventó en 5 años. ¿Y tú? Lee casos y guías en '
        },
        'Círculos Sociales': {
            '1-3': 'Quienes amplían su red después de los 50 reducen 45% el riesgo de depresión. Fortalece tus vínculos con recursos de ',
            '4-6': 'Quienes amplían su red después de los 50 reducen 45% el riesgo de depresión. Fortalece tus vínculos con recursos de ',
            '7-9': 'Quienes amplían su red después de los 50 reducen 45% el riesgo de depresión. Fortalece tus vínculos con recursos de '
        },
        'Familia': {
            '1-3': 'El 60% de quienes refuerzan vínculos familiares logran mayor satisfacción. Descubre consejos en Academia. ',
            '4-6': 'El 60% de quienes refuerzan vínculos familiares logran mayor satisfacción. Descubre consejos en Academia. ',
            '7-9': 'El 60% de quienes refuerzan vínculos familiares logran mayor satisfacción. Descubre consejos en Academia. '
        },
        'Trabajo y Desarrollo Profesional': {
            '1-3': 'El 43% de ejecutivos sin networking temprano pierde oportunidades después de los 60. Aprende cómo potenciar tu carrera en ',
            '4-6': 'El 43% de ejecutivos sin networking temprano pierde oportunidades después de los 60. Aprende cómo potenciar tu carrera en ',
            '7-9': 'El 43% de ejecutivos sin networking temprano pierde oportunidades después de los 60. Aprende cómo potenciar tu carrera en '
        },
        'Ingresos Económicos': {
            '1-3': 'El 78% de quienes planifican con 10 años logran estabilidad en la jubilación. Explora estrategias financieras en ',
            '4-6': 'El 78% de quienes planifican con 10 años logran estabilidad en la jubilación. Explora estrategias financieras en ',
            '7-9': 'El 78% de quienes planifican con 10 años logran estabilidad en la jubilación. Explora estrategias financieras en '
        }
    }
    
};
